




































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {ErroIntegracao} from '@/model/resource/ErroIntegracao'
import {ErroIntegracaoFilterCollection} from '@/model/filter/ErroIntegracaoFilterCollection'
import {ListErroIntegracaoSchema} from '@/schema/resource/ErroIntegracao/ListErroIntegracaoSchema'
import {CsvErroIntegracaoSchema} from '@/schema/resource/ErroIntegracao/CsvErroIntegracaoSchema'
import FilterToggle from '@/components/FilterToggle.vue'
import ErroIntegracaoFilter from '@/components/filters/ErroIntegracaoFilter.vue'

@Component({
  components: {ErroIntegracaoFilter, FilterToggle},
})
export default class ListErroIntegracaoView extends Mixins(MixinQueryRouter) {
  schema = new ListErroIntegracaoSchema()
  collection = new ErroIntegracaoFilterCollection()

  filterOpen = false

  async created() {
    await this.query()
  }

  goToPersistView(item: ErroIntegracao) {
    Helper.pushByName('editErroIntegracao', item.$id)
  }

  closeFilter() {
    this.filterOpen = false
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ErroIntegracaoFilterCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvErroIntegracao()
    new CsvErroIntegracaoSchema().downloadCsv(csv.all())
  }
}
